<div class="d-flex justify-content-center mt-md-5 pt-md-5">

    <div class="col col-md-6 col-lg-3 mt-5 mx-auto">
        <mat-card class="border border-2 border-secondary shadow-none">
            <h3 class="text-secondary text-center">¿Olvidaste tu contraseña?</h3>
            <form [formGroup]="formGroup" class="mt-3">
                <div class="d-flex flex-column">
                    <div class="my-2 text-center" *ngIf="!userInfoParam.email">
                        <span class="fs-5 m-0">Escribe tu correo electrónico *</span>
                        <div class="input-group">
                            <input class="form-control fs-5 mt-2" formControlName="email">
                        </div>
                    </div>
                    <div class="my-2 text-center" *ngIf="userInfoParam.email">
                        <label class="label_title_textfield text-truncate">Escriba su nueva contraseña</label>
                        <input formControlName="password" type="password" class="form-control"
                            aria-describedby="basic-addon1" required minlength="8">
                        <br />
                        <label class="label_title_textfield text-truncate">Repita su contraseña</label>
                        <input formControlName="passwordConfirm" type="password" class="form-control"
                            aria-describedby="basic-addon1" required minlength="8">
                    </div>
                    <button *ngIf="!message" class="fs-5 m-0" type="button"
                        (click)="userInfoParam.email ? modificarPassword() : verifyPageState()" mat-raised-button
                        color="accent">Aceptar</button>

                    <button *ngIf="message" class="fs-5 m-0" type="button" (click)="backToMain()" mat-raised-button
                        color="accent">Cerrar</button>

                    <!-- <button *ngIf="userInfoParam.email" class="fs-5 m-0" type="button" (click)="modificarPassword()"
                        mat-raised-button color="accent">Aceptar</button> -->
                </div>

            </form>
            <div *ngIf="message" [innerHTML]="message" style="text-align: center; margin-top: 20px;"></div>
        </mat-card>
    </div>

</div>

<div *ngIf="cargando" class="cargando">
    <mat-spinner></mat-spinner>
</div>